import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import Container from "./components/Container";
import Auth from "./pages/Auth/Auth";
import SSO from "./pages/Auth/SSO";
import HouseHoldLayout from "./pages/household/HouseHoldLayout";
import StockLayout from "./pages/stock/StockLayout";
import NoDataMessage from "./components/NoDataMessage";
import DocumentTemplate from "./pages/document-template/DocumentTemplate";
import AccountsHeldElsewhere from "./pages/household/AHE/AccountsHeldElsewhere";
import AllocationBlueprintWrapper from "./pages/household/allocation-blueprint/AllocationBlueprintWrapper";
import Assets from "./pages/household/assets/Assets";
import BalanceSheet from "./pages/household/balance-sheet/BalanceSheet";
import Documents from "./pages/household/documents/Documents";
import Gifting from "./pages/household/gifting/Gifting";
import Household from "./pages/household/Household";
import HouseholdDictionary from "./pages/household/HouseholdDictionary";
import NonAssetBalanceSheet from "./pages/household/non-asset-balance-sheet/NonAssetBalanceSheet";
import CompensationDeferralPlan from "./pages/household/plans/CompensationDeferralPlan";
import DeferredCompensationPlan from "./pages/household/plans/DeferredCompensationPlan";
import DeferredLongTermIncentivePlan from "./pages/household/plans/DeferredLongTermIncentivePlan";
import SavingsRestorationPlan from "./pages/household/plans/SavingsRestorationPlan";
import PerformanceStockAwards from "./pages/household/PSU/PerformanceStockAwards";
import RestrictedStockAwards from "./pages/household/RSU/RestrictedStockAwards";
import StockAppreciationRights from "./pages/household/SAR/StockAppreciationRights";
import StrategicGuide from "./pages/household/strategic-guide/StrategicGuide";
import UniquePossibilities from "./pages/household/UP/UniquePossibilities";
import OpenDictionary from "./pages/open-dictionary/OpenDictionary";
import StockDetail from "./pages/stock/StockDetail";
import StockList from "./pages/stock/StockList";
import SystemUsers from "./pages/system-user/SystemUsers";
import NPVWithDisclaimer from "./pages/household/NPV/NetPresentValue";
import ErrorBoundary from "./components/ErrorBoundary";
import AdminConsole from "./pages/admin-console/AdminConsole";
import CacheBusterContainer from "./components/CacheBusterContainer";
import * as Sentry from "@sentry/react";

function App() {
  return <RouterProvider router={router} />;
}

export default App;

const CONTAINER_ROUTES = [
  { route: "/household", element: <HouseholdDictionary /> },
  { route: "/open-dictionary", element: <OpenDictionary /> },
  { route: "/user", element: <SystemUsers /> },
  { route: "/stock", element: <StockList /> },
  { route: "/document-template", element: <DocumentTemplate /> },
  { route: "/admin-console", element: <AdminConsole /> },
];

const HOUSEHOLD_ROUTES = [
  { route: "/household/:id", element: <Household /> },
  { route: "/household/:id/unique-possibilities", element: <UniquePossibilities /> },
  { route: "/household/:id/npv", element: <NPVWithDisclaimer /> },
  { route: "/household/:id/balance-sheet", element: <BalanceSheet /> },
  { route: "/household/:id/non-asset-balance-sheet", element: <NonAssetBalanceSheet /> },
  { route: "/household/:id/allocation-blueprint", element: <AllocationBlueprintWrapper /> },
  { route: "/household/:id/stock-appreciation-rights", element: <StockAppreciationRights /> },
  { route: "/household/:id/strategic-guide", element: <StrategicGuide /> },
  { route: "/household/:id/restricted-stock-awards", element: <RestrictedStockAwards /> },
  { route: "/household/:id/performance-stock-awards", element: <PerformanceStockAwards /> },
  { route: "/household/:id/gifting", element: <Gifting /> },
  { route: "/household/:id/assets", element: <Assets /> },
  { route: "/household/:id/documents", element: <Documents /> },
  { route: "/household/:id/compensation-deferral-plan", element: <CompensationDeferralPlan /> },
  { route: "/household/:id/deferred-compensation-plan", element: <DeferredCompensationPlan /> },
  { route: "/household/:id/savings-restoration-plan", element: <SavingsRestorationPlan /> },
  {
    route: "/household/:id/deferred-long-term-incentive-plan",
    element: <DeferredLongTermIncentivePlan />,
  },
  { route: "/household/:id/accounts-held-elsewhere", element: <AccountsHeldElsewhere /> },
];

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/sso" element={<SSO />} errorElement={<ErrorBoundary />} />
      <Route path="/" element={<Auth />} errorElement={<ErrorBoundary />} />
      <Route element={<CacheBusterContainer />} errorElement={<ErrorBoundary />}>
        <Route element={<Container />} errorElement={<ErrorBoundary />}>
          <Route path="*" element={<NoDataMessage isPageNotFound />} />
          {CONTAINER_ROUTES.map(({ route, element }, i) => (
            <Route key={i} path={route} element={element} errorElement={<ErrorBoundary />} />
          ))}
        </Route>
        <Route element={<HouseHoldLayout />}>
          {HOUSEHOLD_ROUTES.map(({ route, element }, i) => (
            <Route key={i} path={route} element={element} errorElement={<ErrorBoundary />} />
          ))}
        </Route>
        <Route element={<StockLayout />}>
          <Route
            path="/stock/:id/browse"
            element={<StockDetail />}
            errorElement={<ErrorBoundary />}
          />
        </Route>
      </Route>
    </>
  )
);
